import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, IndianRupee, UtensilsCrossed, GraduationCap, Calendar, ClipboardList, ChevronLeft, ChevronRight, Eye } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import MiniTimer from "@/components/landing/MiniTimer";

const screenshots = [
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/mjlcxljl_WhatsApp%20Image%202026-03-13%20at%2018.28.57.jpeg",
    tool: "PM POSHAN Calculator",
    hook: "Student count ଦିଅ — Rice, Dal, Oil ସବୁ quantity ସେକେଣ୍ଡ ରେ!",
    pain: "ପ୍ରତିଦିନ 20 ମିନିଟ୍ ନଷ୍ଟ",
    solve: "ଏବେ ମାତ୍ର 30 ସେକେଣ୍ଡ",
    color: "from-blue-500 to-cyan-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/ok9x8jmd_WhatsApp%20Image%202026-03-13%20at%2018.28.57%20%281%29.jpeg",
    tool: "Salary Calculator",
    hook: "Pay Level ଦିଅ — Basic, DA, HRA, Net Salary ସବୁ ତୁରନ୍ତ!",
    pain: "Calculator ରେ 30 ମିନିଟ୍",
    solve: "App ରେ 30 ସେକେଣ୍ଡ",
    color: "from-green-500 to-emerald-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/ha9ulzhl_WhatsApp%20Image%202026-03-13%20at%2018.28.56%20%281%29.jpeg",
    tool: "Class V & VIII Marks Calculator",
    hook: "FA, SA, Project — ସବୁ marks enter କର, result ତୁରନ୍ତ!",
    pain: "40+ students ପାଇଁ ଦିନ ଲାଗେ",
    solve: "ଏବେ 15 ସେକେଣ୍ଡ / student",
    color: "from-violet-500 to-purple-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/exa9c58c_WhatsApp%20Image%202026-03-13%20at%2018.28.56.jpeg",
    tool: "Holiday Checker 2026",
    hook: "ବର୍ଷର ସବୁ ଛୁଟି — Vacation, Observance ସବୁ ଗୋଟିଏ ଜାଗାରେ!",
    pain: "Calendar ଖୋଜି ଖୋଜି ଥକି ଯାଅ",
    solve: "App ରେ ସବୁ ଛୁଟି ready",
    color: "from-amber-500 to-orange-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/8ju10i15_mdm%20rt.jpeg",
    tool: "MDM Report Generator",
    hook: "Monthly MDM Report — BV, Primary, UP, HS ସବୁ category ready!",
    pain: "Report ପାଇଁ 2-3 ଘଣ୍ଟା",
    solve: "ଏବେ ମାତ୍ର 2 ମିନିଟ୍",
    color: "from-teal-500 to-green-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/56n9frbq_WhatsApp%20Image%202026-03-13%20at%2018.28.59.jpeg",
    tool: "Ladoo Calculator",
    hook: "Ingredient, quantity, cost — per ladoo ସବୁ auto calculate!",
    pain: "Manually ଗଣିଲେ ଭୁଲ ହୁଏ",
    solve: "App ରେ exact calculation",
    color: "from-yellow-500 to-amber-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/7y36yqwo_WhatsApp%20Image%202026-03-13%20at%2018.28.58.jpeg",
    tool: "MDM Message Generator",
    hook: "Student count ଦିଅ — ODIMDM message ସିଧା 15544 କୁ Send!",
    pain: "Message format ମନେ ରଖିବା କଷ୍ଟ",
    solve: "ଗୋଟିଏ click ରେ ready",
    color: "from-indigo-500 to-blue-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/3ujj8kt4_WhatsApp%20Image%202026-03-13%20at%2018.28.58%20%281%29.jpeg",
    tool: "Instant CL Generator",
    hook: "CL Application — ନାମ, ତାରିଖ, କାରଣ ଦିଅ — ready to print!",
    pain: "ହାତରେ ଲେଖିଲେ 25 ମିନିଟ୍",
    solve: "App ରେ 1 ମିନିଟ୍",
    color: "from-rose-500 to-pink-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/jva9z9wu_WhatsApp%20Image%202026-03-13%20at%2018.28.59%20%282%29.jpeg",
    tool: "Ladoo Labor Receipt",
    hook: "ଲାଡୁ ତିଆରି ରସିଦ — CCH ସ୍ୱାକ୍ଷର ସହ ପୂରା format ready!",
    pain: "Receipt ଲେଖିଲେ 20 ମିନିଟ୍",
    solve: "App ରେ ତୁରନ୍ତ generate",
    color: "from-purple-500 to-fuchsia-500",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_odisha-teachers/artifacts/i1q0szkt_WhatsApp%20Image%202026-03-13%20at%2018.28.59%20%281%29.jpeg",
    tool: "Ladoo Material Receipt",
    hook: "ସାମଗ୍ରୀ ରସିଦ — 7 items ର quantity, rate, total auto!",
    pain: "ହିସାବ ଗଣିଲେ ଭୁଲ ହୁଏ",
    solve: "App ରେ 100% accurate",
    color: "from-cyan-500 to-teal-500",
  },
];

export default function AppScreenshotsSection({ downloadLink }) {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const cardWidth = container.offsetWidth;
    const newIndex = dir === "left"
      ? Math.max(0, activeIndex - 1)
      : Math.min(screenshots.length - 1, activeIndex + 1);
    container.scrollTo({ left: cardWidth * newIndex, behavior: "smooth" });
    setActiveIndex(newIndex);
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const handleScroll = () => {
      const idx = Math.round(container.scrollLeft / container.offsetWidth);
      setActiveIndex(idx);
    };
    container.addEventListener("scroll", handleScroll, { passive: true });
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section data-testid="app-screenshots-section" className="py-12 md:py-20 bg-slate-900 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-green-500/10 rounded-full blur-3xl" />

      <div className="relative container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center mb-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-green-500/20 text-green-400 text-xs font-bold uppercase tracking-wide">
            <Eye className="w-3.5 h-3.5" />
            Real App Screenshots
          </span>
        </div>
        <h2
          data-testid="screenshots-headline"
          className="text-3xl md:text-4xl font-bold text-white text-center leading-tight"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          ଦେଖନ୍ତୁ App ଭିତରେ <span className="text-green-400">କ'ଣ ଅଛି</span>
        </h2>
        <p className="mt-2 text-center text-slate-400 text-sm md:text-base max-w-xl mx-auto">
          ଏହି tools ପ୍ରତିଦିନ ହଜାର ହଜାର ଶିକ୍ଷକ ବ୍ୟବହାର କରୁଛନ୍ତି — ଆପଣ ଛାଡ଼ି ଦେବେ?
        </p>

        {/* Scrollable screenshots */}
        <div className="relative mt-8">
          {/* Navigation arrows - desktop */}
          <button
            onClick={() => scroll("left")}
            data-testid="screenshot-prev-btn"
            className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 items-center justify-center text-white hover:bg-white/20 transition"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={() => scroll("right")}
            data-testid="screenshot-next-btn"
            className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 items-center justify-center text-white hover:bg-white/20 transition"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none", WebkitOverflowScrolling: "touch" }}
          >
            {screenshots.map((s, i) => (
              <div
                key={i}
                data-testid={`screenshot-card-${i}`}
                className="snap-center flex-shrink-0 w-full md:w-[340px]"
              >
                <Card className="bg-slate-800 border border-slate-700 overflow-hidden shadow-2xl h-full">
                  {/* Tool name header */}
                  <div className={`bg-gradient-to-r ${s.color} px-4 py-2.5 flex items-center justify-between`}>
                    <span className="text-white font-bold text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                      {s.tool}
                    </span>
                    <span className="bg-white/20 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase">
                      Live
                    </span>
                  </div>

                  {/* Screenshot */}
                  <div className="relative">
                    <img
                      src={s.src}
                      alt={s.tool}
                      className="w-full h-auto"
                      loading="lazy"
                    />
                  </div>

                  {/* Info section */}
                  <CardContent className="p-4 space-y-3">
                    <p className="text-sm text-white font-medium">{s.hook}</p>

                    {/* Before / After pills */}
                    <div className="flex items-center gap-2">
                      <span className="flex-1 text-center bg-red-500/15 text-red-400 text-xs font-bold py-1.5 rounded-lg border border-red-500/20">
                        {s.pain}
                      </span>
                      <span className="text-slate-500 text-xs font-bold">→</span>
                      <span className="flex-1 text-center bg-green-500/15 text-green-400 text-xs font-bold py-1.5 rounded-lg border border-green-500/20">
                        {s.solve}
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>

          {/* Dots indicator */}
          <div className="flex items-center justify-center gap-2 mt-4">
            {screenshots.map((_, i) => (
              <button
                key={i}
                data-testid={`screenshot-dot-${i}`}
                onClick={() => {
                  scrollRef.current?.scrollTo({ left: scrollRef.current.offsetWidth * i, behavior: "smooth" });
                  setActiveIndex(i);
                }}
                className={`w-2 h-2 rounded-full transition-all ${
                  i === activeIndex ? "bg-green-400 w-6" : "bg-slate-600"
                }`}
              />
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 text-center">
          <p className="text-amber-400 text-sm font-bold mb-3">
            ଏହି ସବୁ tools ଆପଣଙ୍କ phone ରେ — ₹199/ବର୍ଷ ରେ ସବୁ unlock!
          </p>
          <Button
            data-testid="screenshots-download-btn"
            asChild
            className="h-12 px-8 bg-green-500 hover:bg-green-600 text-white rounded-full text-base font-bold shadow-lg shadow-green-500/30"
          >
            <a href={downloadLink} target="_blank" rel="noopener noreferrer">
              <Download className="mr-2 w-5 h-5" />
              Download & Start Using Now
            </a>
          </Button>
          <div className="mt-3">
            <a
              href="https://teacherutilitytoolkit.in/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="screenshots-try-online-btn"
              className="inline-flex items-center gap-2 h-12 px-8 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white rounded-full text-base font-bold shadow-xl shadow-orange-500/30 transition-all"
            >
              ⚡ ବିନା Download — ଏଠାରେ ସିଧା ଚଲାନ୍ତୁ FREE!
            </a>
          </div>
          <div className="mt-2 flex justify-center">
            <MiniTimer variant="dark" />
          </div>
          <p className="mt-2 text-slate-500 text-xs">
            ଆଜି Download କଲେ ₹499 ବଦଳରେ ମାତ୍ର ₹199 ରେ Premium ପାଇବେ
          </p>
        </div>
      </div>
    </section>
  );
}
